import { useEffect, useState } from 'react';

const useShiftLasso = (mapRef) => {
  const [shiftLasso, setShiftLasso] = useState(false);

  useEffect(() => {
    const mapDiv = mapRef.current?.getDiv?.();
    if (!mapDiv) return;

    let shiftHeld = false;
    let overMap = false;
    const sync = () => setShiftLasso(shiftHeld && overMap);

    const isEditable = (el) =>
      !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);

    const onKeyDown = (e) => {
      if (e.key === 'Shift' && !isEditable(e.target)) {
        shiftHeld = true;
        sync();
      }
    };
    const onKeyUp = (e) => {
      if (e.key === 'Shift') {
        shiftHeld = false;
        sync();
      }
    };
    const onEnter = () => {
      overMap = true;
      sync();
    };
    const onLeave = () => {
      overMap = false;
      sync();
    };
    const onWindowBlur = () => {
      shiftHeld = false;
      overMap = false;
      sync();
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    window.addEventListener('blur', onWindowBlur);
    mapDiv.addEventListener('mouseenter', onEnter);
    mapDiv.addEventListener('mouseleave', onLeave);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', onWindowBlur);
      mapDiv.removeEventListener('mouseenter', onEnter);
      mapDiv.removeEventListener('mouseleave', onLeave);
    };
  }, [mapRef.current]);

  return shiftLasso;
};

export default useShiftLasso;
